const $clamp = require('clamp');

/*
 * Copyright 2019 Bitban Technologies, S.L.
 * Todos los derechos reservados.
 */

export default () => {
  //Olw carousel initialization:
  var photogallery_slider = $('.photo-carousel .owl-carousel').owlCarousel({
    stageElement: 'ul',
    itemElement: 'li',
    stagePadding: 0,
    navText: ["<i class='fal fa-chevron-left'></i>","<i class='fal fa-chevron-right'></i>"],
    mouseDrag: false,
    touchDrag: false,
    margin: 0,
    nav: true,
    items: 2,
    loop: false
  });

  var itemVignette = $('.photo-carousel .owl-carousel .owl-item').find("div.item > span");
  var totalItems = $('.photo-carousel .owl-carousel .owl-item').length;

  for (var i = 0; i < totalItems; i++){
    $clamp(itemVignette[i], {
      clamp: 2
    });
  }
}
